module.exports = __webpack_public_path__ + "images/category_lp/brand/new/assessment_achievements/3_ad350247cbdeebfb188d199b9343fc83.png";